module.exports = {"Domain":"Domains","AppProfile":"App Profiles","OriginPolicy":"Origin Policies","HtmlPage":"HTML Pages","WafRule":"WAF Rules","Cert":"Certs","ServiceGroup":"Sites","SLB":"SLBS","VSLB":"VSLBS","EDGE":"EDGES","DomainsWithAppProfile":"Domains With AppProfile"}


//////////////////
// WEBPACK FOOTER
// ./src/i18n/en-US/resourceType.json
// module id = KWzU
// module chunks = 3